import type { ClientWebsocket, WsMessageHandler } from '../websockets/clientWebsocket';
import { isPlayoutDeviceStatusGetDto } from '@mimir/common/dto/websocketMessages';
import { invariant } from '@mimir/common/util/invariant';
import type { PlayoutDeviceStatusGetDto } from '@mimir/common/dto/playoutDtos';
import type { WebsocketMessage } from '@mimir/common/dto/websocketMessages';

export class PlayoutWsMessageHandler implements WsMessageHandler {

  constructor(
    private readonly playoutEventHandler: PlayoutEventHandler,
  ) {}

  onWsMessageReceived(message: WebsocketMessage) {
    if (message.type === 'playout_status_update') {
      invariant(isPlayoutDeviceStatusGetDto(message.data), 'Expecting a PlayoutDeviceStatusGetDto');
      this.playoutEventHandler.onStatusChange(message.data);
      return;
    }

  }
}


export interface PlayoutEventHandler {
  onStatusChange:(statuses: PlayoutDeviceStatusGetDto) => void;
}

export type PlayoutWsSubscription = {

  // A function that should be invoked when we no longer want to receive
  // playout messages, such as when navigating away from the playout page.
  cancel: () => void;
};

export function setPlayoutWsMode(
  clientWs: ClientWebsocket,
  playoutEventHandler: PlayoutEventHandler,
): PlayoutWsSubscription {
  const msgHandler = new PlayoutWsMessageHandler(playoutEventHandler);
  clientWs.addMessageHandler(msgHandler);
  clientWs.addMode('playout');
  console.log('playout mode set');
  return {
    cancel: () => {
      console.log('Clearing playout ws mode');
      clientWs.removeMode('playout');
      clientWs.removeMessageHandler(msgHandler);
    }
  };
}
